import AmpleHireImageTag from "../../ample-hire-html-tags/ample-hire-image-tag";

const TableButton = ({
  buttonText,
  buttonIconSrc,
  buttonIconAltText,
  buttonIconCss,
  onClick = () => {},
}) => {
  return (
    <li className="cursor-pointer" onClick={onClick}>
      <a className="flex-center">
        <i>
          <AmpleHireImageTag
            imgSrc={buttonIconSrc}
            altText={buttonIconAltText}
            className={buttonIconCss}
          />
        </i>
        {buttonText}
      </a>
    </li>
  );
};

export default TableButton;
